"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));

var _lodash = require("lodash");

var _auth = require("../../utils/auth");

var _utils = require("../../utils"); // import app components


var db = /*#__PURE__*/function () {
  var _db = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(endpoint, args, source) {
    var contentType,
        user,
        formData,
        cancelTokenSource,
        cleanedUrl,
        result,
        _err$response,
        _err$response$data,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            contentType = _args.length > 3 && _args[3] !== undefined ? _args[3] : 'x-www-form-urlencoded';

            if ((0, _utils.validateAccess)()) {
              _context.next = 4;
              break;
            }

            (0, _auth.logout)({});
            return _context.abrupt("return");

          case 4:
            user = (0, _auth.getUser)();
            _context.prev = 5;
            formData = new FormData();
            Object.keys(args).map(function (key) {
              if (typeof args[key] !== 'undefined') {
                // Transform objects to string
                var value = (0, _lodash.isObject)(args[key]) && contentType === 'x-www-form-urlencoded' ? JSON.stringify(args[key]) : args[key];
                formData.append(key, value);
              }
            }); // Create a new CancelToken source for this request

            cancelTokenSource = _axios.default.CancelToken.source(); // TODO: Move to utils function

            cleanedUrl = source.replace(/\/+$/, ''); // TODO: Make variable to allow for different CMS source

            _context.next = 12;
            return _axios.default.post("".concat(cleanedUrl, "/wp-json/jamcms/v1/").concat(endpoint), formData, {
              cancelToken: cancelTokenSource.token,
              headers: {
                'Content-Type': contentType,
                Authorization: "Bearer ".concat(user.authToken)
              }
            });

          case 12:
            result = _context.sent;
            // Cancel request
            cancelTokenSource.cancel();

            if (!(result !== null && result !== void 0 && result.data)) {
              _context.next = 16;
              break;
            }

            return _context.abrupt("return", result.data);

          case 16:
            _context.next = 21;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](5);

            if (_context.t0 !== null && _context.t0 !== void 0 && (_err$response = _context.t0.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && _err$response$data.message) {
              console.log((0, _htmlReactParser.default)(_context.t0.response.data.message));
            }

          case 21:
            return _context.abrupt("return", null);

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 18]]);
  }));

  function db(_x, _x2, _x3) {
    return _db.apply(this, arguments);
  }

  return db;
}();

var _default = db;
exports.default = _default;